import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { Grid, Container, TextField, useMediaQuery } from '@material-ui/core'
import './Login.scss'
import { useForm } from 'react-hook-form'
import NewFillButton from '../Core/NewFillButton'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'
import { SessionContextStore } from '../../context/SessionContext'
import {
  awaitWithLoading,
  isInFlow,
  showError,
  isInClaimsFlow,
  isInPurchaseFlow,
} from '../../services/utils'
import { useLocation, useHistory } from 'react-router-dom'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import StorageService from '../../services/StorageService'
import { PasswordInput } from '../Core/PasswordInput'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { SessionService } from '../../services/SessionService'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import insuranceApi from '../../api/insurance.api'
import { EMAIL_REGEX } from '../../Constants'
import { ERROR_CODES } from '../../models/errors/ErrorCodes'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import BrokerConfigService from '../../services/BrokerConfigService'

var classNames = require('classnames')

const LogoutSection = () => {
  const [open, setOpen] = React.useState(false)
  const sessionContext = useContext(SessionContextStore)
  const history = useHistory()
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleDisagree = () => {
    setOpen(false)
  }

  const handleAgree = async () => {
    await sessionContext.logout()
    history.push('/login')
    setOpen(false)
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleDisagree}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Logging Out</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree} color="primary">
            Cancel and return
          </Button>
          <Button onClick={handleAgree} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <NewFillButton onClick={handleClickOpen}>Logout</NewFillButton>
    </React.Fragment>
  )
}

export const LoginSection = (props) => {
  const { register, trigger, errors, getValues, setError, clearErrors } =
    useForm()
  const sessionContext = useContext(SessionContextStore)
  const location = useLocation()
  const history = useHistory()
  const [registerMode, setRegisterMode] = useState(
    location.pathname.endsWith('register') ||
      (isInFlow(location.pathname) && !location.pathname.startsWith('/claim'))
  )
  const isBrokerContext =
    SessionService.isBroker() ||
    location.pathname.includes('brokerLogin') ||
    location.pathname.includes('brokerlogin')
  const [showCreateAccountInPurchaseFlow, setShowCreateAccountInPurchaseFlow] =
    useState(false)
  const [showResetPasswordMessage, setShowResetPasswordMessage] =
    useState(false)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const onFBLogin = async (response) => {
    if (response.email && response.accessToken) {
      let res = await socialLogin(
        response.email,
        response.accessToken,
        'facebook'
      )

      if (window.FB) window.FB.logout()

      if (res.ok) redirectAfterLogin()
      else EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const onGoogleLogin = async (response) => {
    if (response.tokenId) {
      let res = await socialLogin(
        response.profileObj.email,
        response.tokenId,
        'google'
      )
      if (res.ok) redirectAfterLogin()
      else EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const userAlreadyExistsResponse = (res) => {
    return (
      res &&
      !res.ok &&
      res.status == 400 &&
      res.data.code &&
      res.data.code == ERROR_CODES.USER_ALREADY_EXISTS_ERROR
    )
  }

  const existsPasswordlessLoginAttempt = (res) => {
    return (
      res &&
      !res.ok &&
      res.status == 400 &&
      res.data.code &&
      res.data.code == ERROR_CODES.PASSWORDLESS_USER_LOGIN_ATTEMPT_ERROR
    )
  }

  const onEmailLogin = async () => {
    let valid = await trigger()
    if (!valid) return
    clearErrors('email')

    let res = {}

    if (isRegisterMode()) {
      if (!isInPurchaseFlow(location.pathname)) {
        res = await awaitWithLoading(
          sessionContext.register(getValues().email, getValues().password)
        )
      } else {
        res = await awaitWithLoading(
          sessionContext.registerPasswordless(getValues().email)
        )
      }
    } else
      res = await awaitWithLoading(
        sessionContext.login(getValues().email, getValues().password)
      )

    if (res.ok) {
      if (
        location.pathname.includes('brokerLogin') &&
        !SessionService.isBroker()
      ) {
        sessionContext.logout()
        showError(
          'This email is not a registered broker account',
          'Please try another email or contact support@skywatch.ai for assistance.'
        )
        return
      }
      redirectAfterLogin()
      window.clarityUpdateUserId(getValues().email)
    } else {
      if (isInFlowRegister() && userAlreadyExistsResponse(res)) {
        setError('email', 'email', res.parsedData.title)
        setShowCreateAccountInPurchaseFlow(true)
      } else if (existsPasswordlessLoginAttempt(res)) {
        setShowResetPasswordMessage(true)
        setShowCreateAccountInPurchaseFlow(false)
      } else {
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    }
  }

  const socialLogin = async (email, token, serviceName) => {
    return await awaitWithLoading(
      sessionContext.socialLogin(email, token, serviceName)
    )
  }

  const createNewAccount = () => {
    if (isInFlow(location.pathname))
      props.titleChanged('register') || setRegisterMode(true)
    else history.push('/insurance/profile')
  }

  const isRegisterMode = () => {
    return registerMode
  }

  const redirectAfterLogin = async () => {
    if (isInFlow(location.pathname) && props.afterLogin) props.afterLogin()
    else if (SessionService.isBroker()) history.push('/broker')
    else {
      let res = await insuranceApi.getActiveInsurances()

      if (res.ok && res.parsedData) history.push('/policy-management')
      else history.push('/insurance')
    }
  }

  const onEnterPressed = (event) => {
    event.key == 'Enter' && onEmailLogin()
  }

  const backToLogin = () => {
    clearErrors('email')
    if (isInFlow(location.pathname))
      props.titleChanged('login') || setRegisterMode(false)
    else history.push('/login')
  }

  const isInFlowRegister = () => {
    return isRegisterMode() && isInPurchaseFlow(location.pathname)
  }

  return (
    <React.Fragment>
      {showResetPasswordMessage ? (
        <>
          <FlexView column hAlignContent={'center'}>
            <MailOutlineIcon className="x-large-icon blue" />
            <br />
            <div className="text-small textcenter">
              A link to verify your email has been sent to{' '}
              {getValues()['email']}
            </div>
            <br />
            <div className="texy-body textcenter bold">
              Please check your email to continue
            </div>
          </FlexView>
        </>
      ) : (
        <>
          {!isBrokerContext && !isInFlowRegister() && (
            <React.Fragment>
              {/* <FlexView hAlignContent={'center'}>
                <FacebookLogin
                    appId="494398664296343"
                    fields="email"
                    icon="fa-facebook"
                    textButton=""
                    autoLoad={false}
                    isMobile={false} 
                    buttonStyle={{width: '130px' ,borderRadius: '10px', backgroundColor: '#3b5998'}}
                    callback={onFBLogin} />
                <div className="margin-left-basic">
                <GoogleLogin 
                    clientId="734682503233-v89okd2g9fe0d1nlgv9dv0n74hiu99nu.apps.googleusercontent.com"
                    buttonText=""
                    autoLoad={false}
                    className="google-btn clickable"
                    cookiePolicy={'single_host_origin'}
                    onSuccess={onGoogleLogin}
                    onFailure={onGoogleLogin} />
                </div>
            </FlexView>
            <div className="text-body black textcenter margin-top-medium margin-bottom-small">Or</div> */}
            </React.Fragment>
          )}
          {isMobile && (
            <>
              <div className="text-title blue bold textcenter">
                Welcome to Voom
              </div>
              <div className="text-body black textcenter margin-top-basic">
                Please {isRegisterMode() ? 'register' : 'login'} to continue
              </div>
              <br />
            </>
          )}
          {!isMobile && (
            <>
              <img
                className="skywatch-logo-small margin-bottom-basic"
                src={BrokerConfigService.getLogo()}
              />
              <div className="text-title bold blue">
                Please login to continue
              </div>
            </>
          )}
          <TextField
            onKeyPress={onEnterPressed}
            fullWidth
            variant="outlined"
            type="email"
            className="margin-top-basic"
            label="Email"
            name="email"
            inputRef={register({
              required: true,
              pattern: {
                value: EMAIL_REGEX,
                message: 'Invalid email address',
              },
            })}
            helperText={
              !!errors.email && (errors.email.message || errors.email.type)
            }
            error={!!errors.email}
          />

          {!isInFlowRegister() && (
            <PasswordInput
              onKeyPress={onEnterPressed}
              fullWidth
              variant="outlined"
              className="margin-top-basic"
              label="Password"
              name="password"
              inputRef={register({
                required: true,
                minLength: {
                  value: 8,
                  message: 'At least 8 characters',
                },
              })}
              error={!!errors.password || !!errors.confirm_password}
              helperText={
                (!!errors.password &&
                  (errors.password.message || errors.password.type)) ||
                (!!errors.confirm_password && 'Passwords do not match')
              }
            />
          )}

          {isRegisterMode() && !isInPurchaseFlow(location.pathname) && (
            <PasswordInput
              onKeyPress={onEnterPressed}
              fullWidth
              variant="outlined"
              className="margin-top-basic"
              label="Confirm password"
              name="confirm_password"
              inputRef={register({
                required: true,
                minLength: 8,
                validate: {
                  value: (value) => getValues().password == value,
                },
              })}
              helperText={!!errors.confirm_password && 'Passwords do not match'}
              error={!!errors.confirm_password}
            />
          )}

          {!isRegisterMode() && (
            <div
              onClick={() => history.push('/forgot-password')}
              className="blue fitcontent underline text-tiny margin-top-small clickable">
              Forgot Password?
            </div>
          )}

          <NewFillButton onClick={onEmailLogin}>
            {isRegisterMode()
              ? isInPurchaseFlow(location.pathname)
                ? 'Continue'
                : 'Sign up'
              : 'Login'}
          </NewFillButton>
          {!isRegisterMode() &&
            !isInClaimsFlow(location.pathname) &&
            FirebaseService.getValue(
              FirebaseConfigKey.REGISTRATION_AVAILABLE
            ) && (
              <React.Fragment>
                <div className="text-tiny black textcenter margin-top-6">
                  Don't have an account?
                </div>
                <div
                  onClick={createNewAccount}
                  className="text-tiny blue underline textcenter clickable">
                  Create a new account
                </div>
              </React.Fragment>
            )}
          {isRegisterMode() &&
            (!isInPurchaseFlow(location.pathname) ||
              showCreateAccountInPurchaseFlow) && (
              <div
                onClick={backToLogin}
                className="text-tiny blue underline textcenter clickable margin-bottom-basic">
                I already have an account
              </div>
            )}
        </>
      )}
    </React.Fragment>
  )
}

export const Login = (props) => {
  const location = useLocation()
  const [title, setTitle] = React.useState(
    isInFlow(location.pathname) ? 'register' : location.pathname.slice(1)
  )
  const [isFlowRegister, setIsFlowRegister] = React.useState(
    isInPurchaseFlow(location.pathname) && title == 'register'
  )
  const isBrokerContext =
    SessionService.isBroker() || location.pathname.includes('brokerLogin')
  const sessionContext = useContext(SessionContextStore)

  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  React.useEffect(() => {
    if (title == 'brokerLogin' || title == 'brokerlogin') setTitle('login')
    setIsFlowRegister(
      isInPurchaseFlow(location.pathname) && title == 'register'
    )
  }, [title])

  React.useEffect(() => {
    if (location.pathname.startsWith('/claim')) setTitle('login')

    if (!isInFlow(location.pathname))
      document.querySelector('body').classList.add('nobackground')

    return function cleanup() {
      if (!isInFlow(location.pathname))
        document.querySelector('body').classList.remove('nobackground')
    }
  }, [])

  return (
    <Grid container className="page">
      <Grid item xs={12} sm={6} md={7}>
        <div
          className={classNames(
            { 'blogin-bg-image': isBrokerContext },
            { 'login-bg-image': !isBrokerContext },
            {
              'login-welcome-section': !isInFlow(location.pathname),
              'flow-login-welcome-section': isInFlow(location.pathname),
            }
          )}>
          {/* <div style={{height: 60}}></div>
                      { 
                          !location.pathname.includes('logout') && !location.pathname.includes('welcome') && !isInFlow(location.pathname) && <div>
                              
                              {
                                  isFlowRegister? 
                                  <div>
                                    <div className="text-title blue bold textcenter">Before we continue...</div>
                                    <div className="text-body black textcenter margin-top-medium">What is your email address?</div>
                                  </div>
                                  :
                                  <div>
                                      {!isMobile && <> 
                                        <div className="text-title blue bold textcenter">Welcome to Voom{!isBrokerContext && '!'}</div>
                                        {isBrokerContext && <div className="text-title blue bold textcenter">Broker Portal!</div>}
                                        <div className="text-body black textcenter margin-top-medium">Please {title} to continue</div>
                                    </>}
                                  </div>
                              }
                            </div>
                      } */}
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={5}>
        <div className="login-info-section margin-top-medium">
          <Container>
            {location.pathname.includes('logout') && <LogoutSection />}
            {(location.pathname.includes('login') ||
              location.pathname.includes('brokerLogin')) && (
              <LoginSection
                {...props}
                titleChanged={(title) => setTitle(title)}
              />
            )}
          </Container>
        </div>
      </Grid>
    </Grid>
  )
}
